import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Hero from '../components/Hero';
import BarraBusca from '../components/BarraBusca';
import { CardPasta, LinksUteis } from '../components/Documentos';
import Carregando from '../components/Carregando';
import { useCatalogo } from '../services/catalogo';
import { formatarData } from '../utils/formatar';
import useTitulo from '../utils/useTitulo';

function Home() {
    useTitulo();
    const navigate = useNavigate();
    const { carregando, erro, indice } = useCatalogo();

    return (
        <>
            <Hero
                eyebrow="Secretaria Municipal de Meio Ambiente"
                titulo="Licenciamento Ambiental"
                sub="Formulários, checklists, modelos, legislação e normas para o licenciamento ambiental municipal. Baixe os documentos organizados por pasta ou busque pelo nome."
            >
                <BarraBusca
                    placeholder="Ex.: loteamento, APP, requerimento, resolução 264…"
                    rotulo="Buscar documentos"
                    aoEnviar={(q) => navigate(q ? `/busca?q=${encodeURIComponent(q)}` : '/busca')}
                />
            </Hero>

            <div className="hub-corpo">
                <Container>
                    <Carregando carregando={carregando} erro={erro}>
                        {indice && (
                            <>
                                <LinksUteis links={indice.links} />

                                <section aria-labelledby="titulo-pastas" className="secao">
                                    <h2 id="titulo-pastas" className="secao__titulo">Documentos por pasta</h2>
                                    <div className="grade-pastas">
                                        {indice.raiz.map((p) => <CardPasta key={p.id} pasta={p} />)}
                                    </div>
                                </section>

                                <p className="atualizacao">
                                    Novos documentos são acrescentados periodicamente.
                                    {indice.geradoEm && <> Última atualização: {formatarData(indice.geradoEm)}.</>}
                                </p>
                            </>
                        )}
                    </Carregando>
                </Container>
            </div>
        </>
    );
}

export default Home;
